import { DateTime, } from "luxon";
import { getChainTime, } from "./getChainTime";


/**
 * Get the current chain time as a Luxon DateTime object
 * 
 * @returns {Promise<DateTime>} Promise resolving to the current chain time as a DateTime object
 */
export const getChainDateTime = async (): Promise<DateTime> => {
	return DateTime.fromMillis(await getChainTime());
}
